import React from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../buttons";
import { logout } from "../../redux/auth/auth.slicer";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",

    "& .MuiButton-root": {
      padding: 4,
    },
    "& .buttonsContainer": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
    },
    "& .avatarContainer": {
      height: "fit-content",
      width: "fit-content",
      borderRadius: "50%",
    },
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  dropDownPaper: {
    textTransform: "none",
    color: theme.palette.text.primary,
    fontWeight: "bold",
    backgroundColor: theme.palette.background.primary,
  },
  userBtn: {
    textTransform: "none",
    color: theme.palette.text.primary,
    fontWeight: "bold",
  },
}));

export default function MenuListComposition(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAdmin } = useSelector((state) => state.walletSlicer);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const handleLogout = (e) => {
    dispatch(logout());
    handleClose(e);
    handleToggle();
  };
  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);
  const { walletAddress } = useSelector((state) => state.auth.user);
  const handleGoToProfilePage = () => {
    navigate("/userprofile/" + walletAddress);
  };
  const handleGoToMintPage = () => {
    navigate("/mintpage");
  };
  return (
    <div className={classes.root}>
      <div
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        className={classes.userBtn}
        disableRipple
      >
        {props.children}
      </div>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper className={classes.dropDownPaper} onClick={handleClose}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                >
                  <MenuItem onClick={handleGoToProfilePage}>Profile</MenuItem>
                  {Boolean(Number(isAdmin)) && (
                    <MenuItem onClick={handleGoToMintPage}>Mint</MenuItem>
                  )}

                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}
